export const hireReactBannerContentEn = {
    shortHeading: "Hire Top Rated React Developers",
    mainHeading: "Drive Digital <span>Innovation</span> with Expert React Development",
    content: "Whether you need a dedicated react developer, a react native development team, or help to augment your own resources. We've got your React Javascript needs to be covered. Deploy react native developers to efficiently & flawlessly craft frontend app solutions from ideation to implementation & final delivery of digital products.",
    buttonText: "Consult our React developers",
    bannerList: [
        { list: "Freelance contractors" },
        { list: "Full-time roles" },
        { list: "Global teams" },
    ]
};

export const hireReactServicesDataEn = {
    shortHeading: "Our React Development Services",
    mainHeading: "Empower Your Business with Scalable React Solutions",
    sectionDescription: "Bitsclan is the best React development company offering top ReactJS & React native development services designed to deliver high-performance, responsive, & scalable web applications to engage users & meet the demands of modern businesses. Hire our expert React JS developers to build interactive, user-friendly interfaces that drive success & elevate your digital presence.",
    buttonText: "Hire React Developers",
    services: [
        {
            title: "Custom ReactJS Web Development",
            description: "We create custom ReactJS web applications designed to match your business needs. You can hire React JS developers who utilize React’s component-based structure to create scalable, flexible, & maintainable solutions that evolve with your growth.",
            icon: "/images/hire-page-icons/hire-react-icons1.svg",
        },
        {
            title: "Custom React Native Development",
            description: "Bitsclan specializes in custom React Native development, delivering reliable, future-ready react apps. Our expert react native developers design scalable, efficient solutions with reusable code, reducing costs & ensuring adaptability, so your applications continue performing as your business expands & changes.",
            icon: "/images/hire-page-icons/hire-react-icons2.svg",
        },
        {
            title: "SaaS Solution Development with React",
            description: "We are React development specialists for SaaS applications, delivering scalable, cloud-based applications. We have the experience to migrate & build from scratch by integrating secure APIs with a constantly live app that minimizes downtime & grows any business to long-term success.",
            icon: "/images/hire-page-icons/hire-react-icons3.svg",
        },
        {
            title: "ReactJS & React Native Consulting Services",
            description: "Partner with Bitsclan, recognized among top React.js consulting companies in usa, to elevate your ReactJS & React Native projects. Our expert offshore react developers ensure smooth integration, fast performance, & scalable applications designed to keep your business competitive in the markets.",
            icon: "/images/hire-page-icons/hire-react-icons4.svg",
        },
        {
            title: "Best React CMS & Portal Development",
            description:
                "We develop a CMS or portal with React by using a headless CMS (like Contentful, Strapi, or Prismic) to manage content & an API & deliver it to your React frontend. We use this headless architecture approach & separate the content backend from the presentation layer. We also build a custom CMS using a Node.js backend & a React frontend, though this requires more development effort.",
            icon: "/images/hire-page-icons/hire-react-icons5.svg",
        },
        {
            title: "React eCommerce Solutions",
            description: "Take your online store to the next level with our React eCommerce solutions. From complete React JS eCommerce websites to React Native starters & customizable templates, we build cohesive & user-friendly platforms to enhance shopping experiences, & grow businesses. ",
            icon: "/images/hire-page-icons/hire-react-icons6.svg",
        },
        {
            title: "ReactJS UI/UX Design & Development",
            description:
                "We build engaging, user-focused web & mobile applications with ReactJS. Using advanced libraries like Material-UI & Ant Design, our dedicated react developers in usa deliver intuitive interfaces, dynamic layouts, & seamless interactions that enhance usability & leave lasting impressions.",
            icon: "/images/hire-page-icons/hire-react-icons7.svg",
        },
        {
            title: "React App Support & Maintenance",
            description:
                "Creating an app is just the start. Our react native app developers offer ongoing support & maintenance to keep your React app running efficiently & securely over time. We assist with regular updates, bug fixes, & compatibility testing, meaning you will reduce downtime & improve performance.",
            icon: "/images/hire-page-icons/hire-react-icons8.svg",
        },
    ]
}

export const hireReactSolutionsDataEn = {
    mainHeading: "Why Choose Bitsclan to Hire ",
    greenHeading: "React Developers",
    sectionDescription: "By combining React with modern frontend & mobile technologies, we create powerful, scalable solutions tailored to your business needs. Whether it’s a web or mobile platform, our approach ensures smooth performance, efficient development, & great user experiences.",
    buttonText: "Hire a developer today",
    solutions: [
        {
            icon: "/images/hire-page-icons/chose-ror-section1.svg",
            title: "Access Vetted Talent",
            description:
                "Meet our React developers, all carefully vetted for their skills & expertise. They also have strong English communication skills, making collaboration easy & effective.",
        },
        {
            icon: "/images/hire-page-icons/chose-ror-section2.svg",
            title: "View matches in seconds",
            description:
                "Skip the hassle of reviewing hundreds of resumes. With HireAI, you can instantly view profiles of React developers who are ready to work on your project.",
        },
        {
            icon: "/images/hire-page-icons/chose-ror-section3.svg",
            title: "Save with global hires",
            description:
                "We give you access to over 450,000 developers from 190 countries, helping you save up to 58% compared to traditional hiring methods.",
            noBorder: true,
        },
        {
            icon: "/images/hire-page-icons/chose-ror-section4.svg",
            title: "Get real human support",
            description:
                "Feel confident in your decision to hire React developers with the hands-on assistance of our experienced recruiters. We guide you every step of the way.",
        },
    ]
}

export const hireReactCombinationsEn = {
    heading: "Top React.js Combinations for Exceptional Development",
    description: "We provide end-to-end ReactJS application development, blending modern back-end technologies for strong, scalable solutions. Hire our expert React developers to ensure exceptional performance, reliable results, & maximum value for your business applications.",
    combinations: [
        {
            title: "ReactJS + Redux",
            description:
                "Redux complements ReactJS by centralizing application data management & simplifying complex state handling. Together, they create scalable, maintainable front-end apps. Hire ReactJS developers for tailored React.js & Redux app integration.",
            icons: [
                { icon: "react.svg", altText: "React.js frontend library" },
                { icon: "redux.svg", altText: "Redux state manager" },
            ],
        },
        {
            title: "ReactJS + TypeScript",
            description:
                "TypeScript, a static type system for React, improves code quality, enhances tooling, & catches errors at compile time, boosting development efficiency. Hire ReactJS experts skilled in TypeScript module development & integration.",
            icons: [
                { icon: "react.svg", altText: "React.js frontend library" },
                { icon: "typescript.svg", altText: "TypeScript typed language" },
            ],
        },
        {
            title: "React + Node.js",
            description:
                "React can pair with Node.js for full-stack JavaScript apps, forming the MERN or MEAN stack, & offering a unified development environment. Dedicated ReactJS developers with extensive experience create unique, dynamic apps by combining React.js & Node.js.",
            icons: [
                { icon: "react.svg", altText: "React.js frontend library" },
                { icon: "nodejs.svg", altText: "Node.js backend runtime" },
            ],
        },
        {
            title: "React + GraphQL",
            description:
                "GraphQL, a query language for APIs, streamlines data fetching when combined with React, minimizing over-fetching & under-fetching. Connect with skilled ReactJS developers to seamlessly integrate ReactJS into your web app & system.",
            icons: [
                { icon: "react.svg", altText: "React.js frontend library" },
                { icon: "graphql.svg", altText: "GraphQL query language" },
            ],
        },
        {
            title: "React + Next.js",
            description:
                "Next.js, a popular React framework, simplifies server-side rendering, routing, & code splitting for SEO-friendly, performant React apps. A top choice for React-based static sites, server-side rendering, & serverless deployment.",
            icons: [
                { icon: "react.svg", altText: "React.js frontend library" },
                { icon: "next-js.svg", altText: "Next.js SSR framework" },
            ],
        },
        {
            title: "React + Java",
            description:
                "ReactJS & Java combination brings together the strengths of a powerful front-end library & a versatile back-end language to deliver cutting-edge web applications. Utilize top ReactJS developers to integrate React.js with Java for tailored applications.",
            icons: [
                { icon: "react.svg", altText: "React.js frontend library" },
                { icon: "java.svg", altText: "Java backend language" },
            ],
        },
    ],
};

export const hireReactStepsEn = {
    heading: "Hire React JS Developers in 4 Easy Steps",
    subHeading:
        "Hiring top React developers is easy with our simple 4-step process. It ensures a smooth, fast, & efficient experience, matching you with the perfect developer for your project.",
    buttonText: "Let’s Find Your Perfect Developer",
    steps: [
        {
            title: "Choose Your Engagement Model",
            description:
                "Select the engagement model that suits your project best whether you need a full-time, part-time, or hourly commitment.",
            icon: "/images/hire-page-setps-icons/icon-1.svg",
        },
        {
            title: "Screen & Select React Developers",
            description:
                "Browse through top React developer profiles & select the ones that best match your requirements.",
            icon: "/images/hire-page-setps-icons/icon-2.svg",
        },
        {
            title: "Conduct One-on-One Interview",
            description:
                "Interview your shortlisted candidates. Ask both practical & theoretical questions to evaluate their skills & fit for your project.",
            icon: "/images/hire-page-setps-icons/icon-3.svg",
        },
        {
            title: "React Developers Onboard",
            description:
                "Once you’ve made your decision, the selected React developer will be onboarded & ready to start working within 24-48 hours.",
            icon: "/images/hire-page-setps-icons/icon-4.svg",
        },
    ],
};

export const hireReactCoverTheStackEn = {
    whereStart: "Frameworks",
    mainHeading: "Hire Expert React Developers for Scalable & Interactive Web Solutions",
    subHeading:
        "We use modern React technologies to deliver robust solutions. When you hire offshore react developers from us, they ensure your business goals are met with scalable, efficient, & future-focused applications.",
    tabs: [
        "Frameworks",
        "Libraries",
        "Tools & Utilities",
        "Database",
        "Tools For PM",
    ],
    tabItems: [
        // Frameworks
        { tab: "Frameworks", icon: "/images/tech-stack-icons/next-js.svg", name: "Next.js" },
        { tab: "Frameworks", icon: "/images/tech-stack-icons/gatsby.svg", name: "Gatsby" },
        { tab: "Frameworks", icon: "/images/tech-stack-icons/remix.svg", name: "Remix" },

        // Libraries
        { tab: "Libraries", icon: "/images/tech-stack-icons/react-query.png", name: "React Query" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/redux.svg", name: "Redux" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/react-hook-form.svg", name: "React Hook Form" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/framer-motion.svg", name: "Framer Motion" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/react.svg", name: "React Router" },
        { tab: "Libraries", icon: "/images/tech-stack-icons/material-ui.svg", name: "Material UI" },

        // Tools & Utilities
        { tab: "Tools & Utilities", icon: "/images/tech-stack-icons/webpack-icon.svg", name: "Webpack" },
        { tab: "Tools & Utilities", icon: "/images/tech-stack-icons/babel.svg", name: "Babel" },
        { tab: "Tools & Utilities", icon: "/images/tech-stack-icons/eslint.svg", name: "ESLint" },
        { tab: "Tools & Utilities", icon: "/images/tech-stack-icons/prettier.svg", name: "Prettier" },
        { tab: "Tools & Utilities", icon: "/images/tech-stack-icons/storybook.svg", name: "Storybook" },
        { tab: "Tools & Utilities", icon: "/images/tech-stack-icons/tailwind.svg", name: "Tailwind CSS" },
        { tab: "Tools & Utilities", icon: "/images/tech-stack-icons/sass.svg", name: "SASS" },

        // Databases
        { tab: "Database", icon: "/images/tech-stack-icons/mongodb.svg", name: "MongoDB" },
        { tab: "Database", icon: "/images/tech-stack-icons/firebase.png", name: "Firebase" },
        { tab: "Database", icon: "/images/tech-stack-icons/postgres.svg", name: "PostgreSQL" },
        { tab: "Database", icon: "/images/tech-stack-icons/mysql-whale-icon.svg", name: "MySQL" },
        { tab: "Database", icon: "/images/tech-stack-icons/supabase.svg", name: "Supabase" },

        // Tools for PM
        { tab: "Tools For PM", icon: "/images/tech-stack-icons/jira.svg", name: "Jira" },
        { tab: "Tools For PM", icon: "/images/tech-stack-icons/trello.svg", name: "Trello" },
        { tab: "Tools For PM", icon: "/images/tech-stack-icons/slack-icon.png", name: "Slack" },
        { tab: "Tools For PM", icon: "/images/tech-stack-icons/zoom-icon.svg", name: "Zoom" },
        { tab: "Tools For PM", icon: "/images/tech-stack-icons/google-meet.webp", name: "Google Meet" }
    ]
};

export const hireReactExpertFactsEn = {
    heading: "Quick Facts About ",
    greenHeading: "Our React Team",
    buttonText: "book an appointment",
    facts: [
        {
            text: "<strong>Experienced React Developers:</strong> Our team has years of hands-on experience in React JS development, building dynamic & scalable web applications.",
        },
        {
            text: "<strong>Expertise in React Ecosystem:</strong> We specialize in building fast & user-friendly interfaces using React & its ecosystem (like Redux, React Router, etc.).",
        },
        {
            text: "<strong>Proven Track Record:</strong> Our React developers have successfully delivered projects across various industries, ensuring smooth, high-performance applications.",
        },
        {
            text: "<strong>Skilled in Integration:</strong> Our developers have experience integrating React apps with various backends, APIs, & third-party services.",
        },
        {
            text: "<strong>Responsive Development:</strong> We ensure that your React applications are fully responsive & work smoothly across all devices.",
        },
        {
            text: "<strong>Dedicated Support:</strong> Our team provides continuous support & maintenance for React apps, ensuring they stay up-to-date & efficient.",
        },
    ],
};

export const hireAppIdesContentEn = {
    heading: "Not sure about your app idea? Get your prototype up in 6-8 weeks!",
    sectionDescription: "Have an idea but unsure how to proceed? Our Golang experts can help you build a functional prototype in just 6-8 weeks! Validate your vision, test user engagement, & establish a strong foundation for success with our expert development services."
}

export const hireReactPageEngagementModelsEn = {
    headingContent: [
        { text: "Our Flexible" },
        { text: "Engagement Models" }
    ],
    discription:
        "Choose the engagement model that fits your project needs! Whether you need full-time, part-time, or hourly developers, we offer flexible options to ensure seamless collaboration & maximum efficiency throughout your project.",
    buttonText: "Get Started Now",
    hiringDetails: [
        {
            text: "Hourly Hiring",
            hours: "48",
            timeUnit: "hours",
            icon: "time.svg",
            bgColor: "#FDFDFF",
            durationLabel: "Duration", // Dynamic label
            duration: "8 Hrs/Day",     // Dynamic value
            minimumDaysLabel: "Minimum Days", // Dynamic label
            minimumDays: "30 Days",           // Dynamic value
            billingLabel: "Billing",       // Dynamic label
            billing: "Monthly",            // Dynamic value
            startWorkPhrase: "Start work in "
        },
        {
            text: "Full Time Hiring",
            hours: "72",
            timeUnit: "hours",
            icon: "full-time.svg",
            bgColor: "#FFFEFA",
            durationLabel: "Duration",
            duration: "8 Hrs/Day",
            minimumDaysLabel: "Minimum Days",
            minimumDays: "30 Days",
            billingLabel: "Billing",
            billing: "Monthly",
            startWorkPhrase: "Get started within "
        },
        {
            text: "Part Time Hiring",
            hours: "48",
            timeUnit: "hours",
            icon: "part-time.svg",
            bgColor: "#FDFFFA",
            durationLabel: "Duration",
            duration: "8 Hrs/Day",
            minimumDaysLabel: "Minimum Days",
            minimumDays: "30 Days",
            billingLabel: "Billing",
            billing: "Monthly",
            startWorkPhrase: "Launch in "
        },
    ]
}

export const reactFaqContentEn = {
    mainHeading: "Frequently Asked Questions about React.js Development",
    // subHeading: "Explore our React development services for tailored web solutions, API creation, & deployment management!",
    faqData: [
        {
            id: "collapseOne",
            question: "How soon can React.js engineers start working on my project?",
            answer:
                "At Bitsclan IT Solutions, our React.js engineers can be onboarded within 3–5 business days after we confirm your project requirements. We manage the entire onboarding process including repository setup, environment configuration, and communication tools ensuring an immediate start without downtime.",
        },
        {
            id: "collapseTwo",
            question: "What type of projects can your React.js developers handle?",
            answer:
                "Our React.js engineers build a wide range of web applications from enterprise dashboards and SaaS platforms to eCommerce stores, AI-integrated interfaces, and real-time data systems. Whether it’s a greenfield project or modernizing existing code, our developers focus on performance, scalability, and maintainability.",
        },
        {
            id: "collapseThree",
            question: "How do you ensure React.js developer quality and technical expertise?",
            answer:
                "Every React.js developer at Bitsclan IT Solutions goes through a multi-stage vetting process, including live coding tests, architecture assessments, and real-world scenario simulations. You’ll work only with engineers who have production-grade experience in React 18+, TypeScript, Redux Toolkit, and REST/GraphQL APIs.",
        },
        {
            id: "collapseFour",
            question: "Can your React.js engineers collaborate with our in-house team?",
            answer:
                "Yes. Our developers integrate directly with your existing workflow and tools, whether you use Slack, Jira, Trello, or Asana. They join your daily standups, sprint reviews, and code reviews, ensuring complete visibility and collaboration throughout development.",
        },
        {
            id: "collapseFive",
            question: "What technologies and tools do your React.js developers use?",
            answer:
                "Our engineers specialize in React 18+, Next.js, TypeScript, Redux, Tailwind CSS, Material UI, and REST/GraphQL APIs. They also work with build and testing tools like Vite, Jest, Cypress, and ESLint, ensuring high performance and clean, maintainable code.",
        },
        {
            id: "collapseSix",
            question: "How do you ensure front-end performance and scalability?",
            answer:
                "We follow component-driven architecture, implement lazy loading, code splitting, and state management optimization for smoother user experiences. Every build is tested for lighthouse scores, bundle size, and browser performance before deployment.",
        },
        {
            id: "collapseSeven",
            question: "Can I scale my React.js development team during the project?",
            answer:
                "Absolutely. You can add or remove developers within days depending on your project phase. Our flexible engagement model allows scaling based on release cycles, product roadmap, or budget adjustments without long-term lock-ins.",
        },
        {
            id: "collapseEight",
            question: "What if a React.js developer isn’t the right fit for our project?",
            answer:
                "If a developer doesn’t align with your team or expectations, we’ll replace them immediately at no extra cost. Your delivery quality and project momentum always remain our top priority.",
        },
        {
            id: "collapseNine",
            question: "How do you handle offboarding or project handovers?",
            answer:
                "Before any transition, we conduct a structured knowledge transfer, including code documentation, UI/UX design handoffs, and deployment instructions. All source code and assets remain your exclusive IP, secured under strict access controls.",
        },
        {
            id: "collapseTen",
            question: "Do you offer post-launch support and maintenance for React.js applications?",
            answer:
                "Yes. We provide ongoing support for bug fixes, feature updates, and performance optimization after launch. You can also opt for retainer models for continuous improvements, version upgrades, or UX enhancements.",
        },
    ]
};

export const softwareCompanyCtaReact = {
    heading: "Your Ideal React Developer is Just a Few Clicks Away!",
    subHeading: "Kick Off With Your Project Today",
    buttonText: "Hire Now",
}

export const mainBannerImgReact = {
    backgroundImage: `url(/images/hire-page-images/hire-react.avif)`,
    factBackgroundImage: `url(/images/hire-page-images/hire-react.avif)`,
};

export const hirePageStacks = [
    {
        title: "Junior React Developer",
        description: [
            "2 Years' experience",
            "Fresh perspectives & innovative ideas",
            "Dedicated to explore web development",
        ],
        linkText: "Connect to Hire",
        link: "#",
        borderClass: "border-1",
    },
    {
        title: "Senior React Developer",
        description: [
            "2+ years' experience",
            "Leadership in complex projects",
            "Proven app deployment success",
        ],
        linkText: "Connect to Hire",
        link: "#",
        borderClass: "border-2",
    },
    {
        title: "React Tech Lead",
        description: [
            "5+ years' experience",
            "Skilled with Jira, Asana, MS Teams, etc.",
            "Suitable when you Hire Web App Team",
        ],
        linkText: "Connect to Hire",
        link: "#",
        borderClass: "border-3",
    },
];

export const benefits = [
    {
        service: "React CMS Development",
        description: "Get an upper hand on your web content, augment efficiency, & develop a shared environment with our React CMS solutions."
    },
    {
        service: "React Migrations",
        description: "Our React engineers strategically migrate legacy content into modern systems in a secured, error-free, & robust way."
    },
    {
        service: "Advanced React Programming",
        description: "Our experts have extensive experience in using React tech stack for tangible results to reach your business vision."
    },
    {
        service: "React Integration & Optimization",
        description: "Leverage the full-scale potential of React integration & optimization functionalities for your app development needs."
    },
    {
        service: "Customized React Solutions",
        description: "Our React developers delve into ideation, reinvention, & scale development as per your enterprise's unique IT demands."
    },
    {
        service: "React eCommerce App",
        description: "With using modern React tools & technologies, we have a proven track record of developing scalable & secured eCommerce sites."
    }
];

export const slidesData = [
    {
        title: "Rapid Development",
        content:
            "React’s built-in tools & features allow for faster development, reducing time-to-market.",
        backgroundClass: "bg-1",
    },
    {
        title: "Scalability",
        content:
            "React is designed to handle high-traffic & complex applications, making it perfect for growing businesses",
        backgroundClass: "bg-2",
    },
    {
        title: "Security",
        content:
            "With built-in protection against common security threats like SQL injection & cross-site scripting, React ensures secure applications",
        backgroundClass: "bg-3",
    },
    {
        title: "Versatility",
        content:
            "From simple websites to complex web apps, React is flexible enough to handle a variety of development needs",
        backgroundClass: "bg-4",
    },
    {
        title: "Maintainability",
        content:
            'Its clean architecture & "Don’t Repeat Yourself" (DRY) principle make React applications easy to manage & scale over time.',
        backgroundClass: "bg-1",
    },
];



export const WhoWeServeData = [
    {
        icon: "/images/servie-icon/startups.svg",
        title: "Budget savings",
        description: "Assembling a local React team is unavoidably expensive. By approaching Innowise. you bypass many hurdles & avoid redundantexpenses such as training fees. taxes. & software licenses.",
        link: "#",
        borderClass: "border-1",
    },
    {
        icon: "/images/servie-icon/company.png",
        title: "Software product companies",
        description: "When you hire ROR developers. you avoid the risks of budget overruns & missed deadlines. Innowise provides solid risk management plans & has an array of risk mitigation measures",
        link: "#",
        borderClass: "border-2",
    },
    {
        icon: "/images/servie-icon/industries.svg",
        title: "Enterprises from 30+ industries",
        description:
            "Innowise has experts with excellent development backgrounds. so you can rest assured that your project is in good hands. Pyrggyelgprneg",
        link: "#",
        borderClass: "border-3",
    },
];

export const hirePageDeliver = [
    {
        image: "/images/hire-page-images/card-1.avif",
        title: "Complex SaaS systems",
        description: "Innowise provides its expertise in the area of building complex platforms for businesses to streamline workflows. The main applications we develop include HRM, CRM, ERP, accounting software, etc."
    },
    {
        image: "/images/hire-page-images/card-2.avif", // Assumed path based on provided example
        title: "Complex SaaS systems",
        description: "Innowise provides its expertise in the area of building complex platforms for businesses to streamline workflows. The main applications we develop include HRM, CRM, ERP, accounting software, etc."
    },
    {
        image: "/images/hire-page-images/card-3.avif", // Assumed path based on provided example
        title: "Complex SaaS systems",
        description: "Innowise provides its expertise in the area of building complex platforms for businesses to streamline workflows. The main applications we develop include HRM, CRM, ERP, accounting software, etc."
    },
];